import React from 'react';
import styles from './About.module.css';

function About() {
  return (
    <section id="about" className={styles.section}>
      <h2 className={styles.sectionTitle}>Our Story</h2>
      <div className={styles.sectionContent}>
        <p>
          Ragged Spade LLC was born from hands-on experience with the challenges of running a physical product business.
          After growing garlic and produce as a side venture, we learned firsthand about inventory management, spoilage,
          logistics, and the constraints of physical products.
        </p>
        <p>
          The pivot to digital products was simple: software doesn't spoil, scales infinitely, and offers better work-life balance.
          With many years of experience in product lifecycle management and product design, we bring real-world problem-solving
          to every app we build.
        </p>
        <p>
          Our mission is straightforward: solve practical problems with well-designed digital tools, and throw in some fun along
          the way. Every app we create addresses a real need—whether it's saving time at an auction, diagnosing a broken appliance,
          or just giving your brain a workout.
        </p>
      </div>

      <div className={styles.featuresGrid}>
        <div className={styles.featureCard}>
          <h3>Experience-Driven</h3>
          <p>Years of product design and lifecycle management inform every decision we make.</p>
        </div>
        <div className={styles.featureCard}>
          <h3>Problem Solvers</h3>
          <p>We build tools that address real-world challenges with practical solutions.</p>
        </div>
        <div className={styles.featureCard}>
          <h3>Quality First</h3>
          <p>Every app is crafted with attention to detail and a focus on user experience.</p>
        </div>
      </div>
    </section>
  );
}

export default About;
